import { t } from "i18next";
import * as yup from "yup";
import { Dictionary } from "../localization/dictionary";
import ajaxClient, { MaxServerError } from "../../../js/common/AjaxClient";
import { Validation } from "../localization/localeValidation";
import eshopFormValidationService from "../general/EshopFormValidationService";
import ProductDetailPageTypeConfig from "./ProductDetailPageTypeConfig";
import elementService from "@/common/ElementService";

interface SubscribePackageWatchdog {
    html: string;
}

const subscribePackageWatchdogSchema = yup.object({
    email: yup.string().trim()
        .lowercase()
        .matches(Validation.EmailRegEx, t("header:validEmail"))
        .required("E‑mail je povinný"),
}).required();
type SubscribePackageWatchdogFormSchema = yup.InferType<typeof subscribePackageWatchdogSchema>;

export default new class SubscribePackageWatchdogFormService {
    private errorElement: HTMLDivElement | undefined;

    public init(productDetailPageTypeConfig: ProductDetailPageTypeConfig): void {
        const packageWatchdogForm = elementService.querySelector<HTMLFormElement>("#js-package-watchdog-form");

        eshopFormValidationService.init<SubscribePackageWatchdogFormSchema>(packageWatchdogForm, subscribePackageWatchdogSchema, {
            onValidSubmit: (): void => void this.submitPackageWatchdogForm(packageWatchdogForm, productDetailPageTypeConfig),
        });
    }

    private showEmailErrorWhenNotExists(packageWatchdogForm: HTMLFormElement): void {
        if (this.errorElement !== undefined) {
            return;
        }

        const errorElement = document.createElement("div");
        errorElement.classList.add("error");
        errorElement.textContent = Dictionary.Default.PleaseInsertValidEmail;

        const emailInputElement = elementService.elementQuerySelector<HTMLInputElement>(packageWatchdogForm, "#js-package-watchdog-email");

        emailInputElement.insertBefore(errorElement, emailInputElement.nextSibling);

        this.errorElement = errorElement;
    }

    private async submitPackageWatchdogForm(packageWatchdogForm: HTMLFormElement, productDetailPageTypeConfig: ProductDetailPageTypeConfig): Promise<void> {
        try {
            const response = await ajaxClient.post<SubscribePackageWatchdog>(
                "/EshopWatchdog/jsSubscribePackageWatchdog",
                {
                    email: elementService.elementQuerySelector<HTMLInputElement>(packageWatchdogForm, "#js-package-watchdog-email").value.trim(),
                    packageId: productDetailPageTypeConfig.packageId,
                },
            );

            const detailSoldSubmittedContainer = elementService.querySelector<HTMLDivElement>("#js-detail-sold-submitted");
            const detailSoldContainer = elementService.querySelector<HTMLDivElement>("#js-detail-sold");

            detailSoldSubmittedContainer.classList.remove("hidden");
            detailSoldContainer.classList.add("hidden");
            detailSoldSubmittedContainer.innerHTML = response.html;
        } catch (error) {
            if (error instanceof MaxServerError) {
                this.showEmailErrorWhenNotExists(packageWatchdogForm);

                return;
            }

            throw error;
        }
    }
}();
